var React = require('react');

function ArrowLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"className":"cls-2","d":"M4.7,65.5,33,123.16V131L0,65.5,33,0V7.88Z"}));
}

ArrowLeft.defaultProps = {"viewBox":"0 0 33 131"};

module.exports = ArrowLeft;

ArrowLeft.default = ArrowLeft;
